// extracted by mini-css-extract-plugin
module.exports = {"ad-text":"styles-m__ad-text__2g4n1"};